module.exports = __webpack_public_path__ + "img/relogio-analogico.1c3be830.jpeg";